<template>
  <v-card>
    <div style="width: 100%; position: relative;">
      <v-btn
        icon
        style="position: absolute; right: 20px; top: 25px;"
        @click="closeModal"
      >
        <v-icon size="30">
          {{ icons.mdiClose }}
        </v-icon>
      </v-btn>
    </div>
    <div class="modal-content">
      <div
        class="d-flex align-center"
        style="gap: 16px;"
      >
        <v-icon
          size="24"
          color="warning"
        >
          {{ icons.mdiAlertOutline }}
        </v-icon>
        <h3 style="font-weight: 600; font-size: 18px;">
          Motivo da recusa
        </h3>
      </div>
      <div style="margin-top: 16px;">
        <p style="font-weight: 500; font-size: 14px; color: #E7E3FC;">
          Explique de forma geral por que este checklist está sendo recusado
        </p>
      </div>
      <v-form
        ref="form"
        style="margin-top: 32px;"
      >
        <div class="form-group">
          <h3 style="font-weight: 600; font-size: 15px; margin-bottom: 8px;">
            Motivo geral da recusa
          </h3>
          <v-textarea
            v-model="reason"
            outlined
            dense
            label="Descrição"
            :rules="[rules.required]"
            rows="4"
          />
        </div>
      </v-form>
      <div class="d-flex justify-center">
        <v-btn
          color="error"
          :loading="isLoading"
          @click="handleDisapprove"
        >
          <div
            class="d-flex align-center"
            style="gap: 10px;"
          >
            <v-icon>{{ icons.mdiThumbDown }}</v-icon>
            <span>RECUSAR</span>
          </div>
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mdiAlertOutline, mdiClose, mdiThumbDown } from '@mdi/js'

export default {
  name: 'DisapproveChecklistModal',
  data() {
    return {
      icons: {
        mdiClose,
        mdiAlertOutline,
        mdiThumbDown,
      },
      reason: '',
      isLoading: false,
      rules: {
        required: value => !!value || 'Campo obrigatório',
      },
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    async handleDisapprove() {
      const isValid = this.$refs.form.validate()
      if (!isValid) return

      try {
        this.isLoading = true

        // Emitir evento com o motivo da recusa
        this.$emit('disapprove', this.reason)

        // Fechar modal
        this.closeModal()
      } catch (error) {
        console.error('Erro ao recusar checklist:', error)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style scoped>
.modal-content {
  padding: 60px 40px 40px 40px;
}

.form-group {
  width: 100%;
}
</style>
